import { login, logout, getInfo, getMenu, GetWeixInfo, WeixinLogin, Binding } from '@/api/login'
import {
  getLoginInfo,
  setLoginInfo,
  removeLoginInfo,
  setWeixInfo,
  removeWeixInfo,
  getWeixInfo,
  getWeixLoginInfo,
  setWeixLoginInfo,
  removeWeixLoginInfo,
  getLoginType,
  setLoginType,
  removeLoginType
} from '@/utils/auth'

const user = {
  state: {
    loginInfo: getLoginInfo(),
    weixLoginInfo: getWeixLoginInfo(),
    weixInfo: getWeixInfo(),
    name: '',
    menustate: false,
    info: {},
    menus: [],
  },

  mutations: {
    SET_WEIXLOGININFO: (state, weixLoginInfo) => {
      state.weixLoginInfo = weixLoginInfo
    },
    SET_LOGININFO: (state, loginInfo) => {
      state.loginInfo = loginInfo
    },
    SET_MENUSTATE: (state, menustate) => {
      state.menustate = menustate
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_WEIXINFO: (state, weixInfo) => {
      state.weixInfo = weixInfo
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          setLoginType('login')
          setLoginInfo(response.Data)
          commit('SET_LOGININFO', response.Data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.Data
          setWeixInfo(data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取微信信息
    GetWeixInfo({ commit, state }, code) {
      return new Promise((resolve, reject) => {
        GetWeixInfo(code).then(response => {
          const data = response.Data
          if(data) {
            setWeixInfo(data)
            commit('SET_WEIXINFO', data)
          }
          // if(response.Status === 1) {
          //
          // } else {
          //   removeWeixInfo()
          //   window.location.href = 'http://web.swiftnb.com'
          // }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 微信登录
    WeixinLogin({ commit, state }, Unionid) {
      return new Promise((resolve, reject) => {
        WeixinLogin(Unionid).then(response => {
          const data = response.Data
          if(data) {
            setLoginType('weix')
            setWeixLoginInfo(data)
            commit('SET_WEIXLOGININFO', data)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    FedLogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          removeLoginType()
          commit('SET_MENUS', [])
          commit('SET_LOGININFO', '')
          removeLoginInfo()
          removeWeixInfo()
          removeWeixLoginInfo()
          localStorage.removeItem('Village')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取菜单
    UserMenu({ commit, state }) {
      return new Promise((resolve, reject) => {
        let Key = ''
        if(getLoginType() === 'weix') {
          Key = getWeixLoginInfo().Key
        } else {
          Key = getLoginInfo().Key
        }
        commit('SET_MENUS', [])
        getMenu(Key).then(response => {
          const data = response
          if (!data.Data) {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_MENUS', data.Data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}

export default user
